import { useIntl } from 'react-intl';

export const withIntl = Component => props => {
    const intl = useIntl();
    return <Component {...props} intl={intl} />;
};
